import { render, staticRenderFns } from "./DadosCasamento.vue?vue&type=template&id=08c1c66b&"
import script from "./DadosCasamento.vue?vue&type=script&lang=js&"
export * from "./DadosCasamento.vue?vue&type=script&lang=js&"
import style0 from "./DadosCasamento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports